import type { ComponentType, PropsWithChildren } from 'react'
import { useMemo } from 'react'

import { useUseCasesQuery } from '@segment/api/routes/useCases/queries'

import type { FiltersState } from '@segment/api/types/common'

import type { NextPageTriggerProps } from '@segment/utils/useNextPageTrigger'
import useNextPageTrigger from '@segment/utils/useNextPageTrigger'

export const useUseCasesGrid = (
  filtersState: FiltersState,
  triggerComponent?: ComponentType<PropsWithChildren<NextPageTriggerProps>>
) => {
  const { data, isLoading, hasNextPage, fetchNextPage, error, isFetchingNextPage } = useUseCasesQuery({
    args: [{ ...filtersState }],
  })

  const pages = useMemo(() => data?.pages?.flatMap((collection) => collection?.items ?? []) ?? [], [data?.pages])

  const nextPageTrigger = useNextPageTrigger({
    isLoading,
    totalDownloadedPages: data?.pages.length ?? -1,
    hasNextPage,
    error,
    onNextPage() {
      fetchNextPage()
    },
    loadMargin: `0%`,
    NextPageTrigger: triggerComponent,
  })

  return { pages, isLoading, nextPageTrigger, isFetchingNextPage, hasNextPage }
}
